import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Layout from "../../Layout";
import { Typography } from "@material-ui/core";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Button from "@material-ui/core/Button";
import useApi from "Hooks/useApi";
import useAuth from "Hooks/useAuth";
import MuiAlert from "@material-ui/lab/Alert";
import useError from "Hooks/useError";
import { message } from "constants/message";
import googleAnalytics from "fuction/googleAnalytics";

const useStyles = makeStyles((theme) => ({
  submit: {
    marginTop: theme.spacing(3),
  },
  messsageWrapper: {
    marginTop: theme.spacing(1),
  },
}));

export default function ChangePassword(props) {
  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();
  const stateError = useError();
  const messages = message();

  const [current_password, setCurrentPassword] = React.useState("");
  const [new_password, setNewPassword] = React.useState("");
  const [new_password_confirm, setNewPasswordConfirm] = React.useState("");

  const [isSuccess, setIsSuccess] = React.useState(false);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - パスワード変更";

    stateError.initialize();
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id)
  }, [props.location.pathname]);

  const handleSubmit = (event) => {
    event.preventDefault();
    request({
      method: "PUT",
      url: `config/:account_id/password`,
      data: {
        current_password,
        new_password,
        new_password_confirm,
      },
    })
      .then((data) => {
        // tokenを更新
        localStorage.setItem("token", data.data.bearer_token);
        auth.dispatch({ type: "setTokenResult", payload: data.data.bearer_token });
        stateError.initialize();
        setIsSuccess(true);
      })
      .catch((error) => {
        setIsSuccess(false);
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  // パスワード入力形式確認用バリデーションを追加
  ValidatorForm.addValidationRule('checkPassword', (value) => {
    if (!value) return true; 
    // パスワードの正規表現
    //   (?=.*?[\u0021-\u002f\u003a-\u0040\u005b-\u0060\u007b-\u007e]) # lookahead punctuations
    //   (?=.*?[\u0030-\u0039])                                        # lookahead digits
    //   (?=.*?[\u0041-\u005a])                                        # lookahead upper case alphabets
    //   (?=.*?[\u0061-\u007a])                                        # lookahead lower case alphabets
    //   [\u0021-\u007e]{8,32}                                         # 8 to 32 of ascii printables
    const regexp = /^((?=.*?[\u0021-\u002f\u003a-\u0040\u005b-\u0060\u007b-\u007e])(?=.*?[\u0030-\u0039])(?=.*?[\u0041-\u005a])(?=.*?[\u0061-\u007a])([\u0021-\u007e]{8,32}))$/;

    if (!regexp.test(value)) {
      return false;
    } else {
      return true;
    }
  });

  // パスワード入力確認用バリデーションを追加
  ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
    if (value !== new_password) {
        return false;
    }
    return true;
  });

  const onError = () => {
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  return (
    <Layout
      content={
        <Grid>
          <Grid item>
            <Typography variant="h6" component="h6">
              パスワード変更
            </Typography>
          </Grid>

          <ValidatorForm 
            onSubmit={handleSubmit}
            onError={onError}
          >
            <Grid item>
              <TextValidator
                type="password"
                label="現在のパスワード*"
                fullWidth
                value={current_password}
                onChange={(event) => setCurrentPassword(event.target.value)}
                validators={['required']}
                errorMessages={[messages.validation.required]}
              />
            </Grid>
            <Grid item>
              <TextValidator
                type="password"
                label="新しいパスワード*"
                fullWidth
                value={new_password}
                onChange={(event) => setNewPassword(event.target.value)}
                validators={['required', 'checkPassword']}
                errorMessages={[
                  messages.validation.required,
                  messages.validation.isPasswordRegexp
                ]}
              />
            </Grid>
            <Grid item>
              <TextValidator
                type="password"
                label="新しいパスワード（再入力）*"
                fullWidth
                value={new_password_confirm}
                onChange={(event) => setNewPasswordConfirm(event.target.value)}
                validators={['required', 'isPasswordMatch']}
                errorMessages={[
                  messages.validation.required,
                  messages.validation.isPasswordMatch,
                ]}
              />
            </Grid>

            {isSuccess && (
              <div className={classes.messsageWrapper}>
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  severity="success"
                  style={{ marginTop: 10 }}
                >
                  パスワードを変更しました
                </MuiAlert>
              </div>
            )}
            {stateError.state.isError && (
              <div className={classes.messsageWrapper}>
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  severity="error"
                  className={classes.toast}
                >
                  {stateError.state.errorMsg}
                </MuiAlert>
              </div>
            )}
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              className={classes.submit}
            >
              <Button
                variant="contained"
                size="medium"
                color="primary"
                type="submit"
              >
                変更
              </Button>
            </Grid>
          </ValidatorForm>
        </Grid>
      }
    />
  );
}
